import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { DESIGN_SERVICES, IMAGES } from "@/data/content";

export default function InteriorDesign() {
  return (
    <div data-testid="page-interior-design">
      <PageHero
        overline="— Service / 02"
        title="Interior &"
        accent="cabinetry design."
        body="Design expertise with particular strength in kitchens, bathrooms, custom millwork and spatial presentation — considered with aesthetics, function, lighting, materials and production in mind."
        image={IMAGES.kitchen}
        testid="interior-hero"
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 grid md:grid-cols-12 gap-10">
        {DESIGN_SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 40} className="md:col-span-6">
            <div className="border-t border-white/5 pt-6 pb-8">
              <div className="flex items-baseline gap-5">
                <span className="num text-2xl text-[#B58B5D]">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif text-2xl text-[#EAEAEA] mb-3">{s.title}</h3>
                  <p className="text-[15px] text-[#A3A3A3] leading-relaxed">{s.body}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="bg-[#0E0E0E] border-y border-white/5 py-24" data-testid="design-advantage">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-center">
          <Reveal className="md:col-span-6">
            <div className="aspect-[4/3] overflow-hidden border border-white/5">
              <img src={IMAGES.bath} alt="" className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal className="md:col-span-6" delay={120}>
            <div className="overline mb-3">Design-to-production advantage</div>
            <h2 className="font-serif text-4xl mb-6 leading-tight">A concept assessed for production reality from the first sketch.</h2>
            <p className="text-[#A3A3A3] text-lg leading-relaxed">
              Because Designlayer understands Cabinet Vision, cabinetry construction and
              manufacturing documentation, design decisions can be assessed for their production
              implications earlier — reducing the gap between an attractive concept and a buildable
              cabinetry solution.
            </p>
            <Link to="/cabinet-vision" className="dl-btn mt-8">See production systems</Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
